function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getContactFormConfigById, TEST_CONTACT_SALES_HUBSPOT_FORM_ID, TEST_PORTAL_ID } from "client/services/hubspot-service/contact-form-config";
import { generateHiddenData, getValueFromHSFields, sendHubspotForm } from "client/services/hubspot-service/hubspot-service";
import { CONTACT_SALES_BACK_BUTTON_CLICKED, CONTACT_SALES_ENRICHEMNT_CALL_FAILED, CONTACT_SALES_ENRICHEMNT_CALL_SUCCESS, CONTACT_SALES_FORM_SUBMISSION_FAILED, HUBSPOT_FORM_INPUT_BLUR, HUBSPOT_FORM_INPUT_TYPED, HUBSPOT_FORM_READY, HUBSPOT_FORM_SUBMIT_CLICKED, HUBSPOT_FORM_SUBMIT_FAILED, HUBSPOT_FORM_TEST_SUBMIT_FAILED } from "constants/bigbrain-event-types";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import { GARTNER_CAMPAIGN_ID, IPO_CAMPAIGN_ID } from "constants/sales/campaigns";
import BaseForm from "segments/desktop/core-components/base-form/base-form";
import { withAbTests } from "contexts/ab-tests-context";
import { trackEvent } from "services/bigbrain-service";
import { handleClientException } from "client/services/exceptions-handling-service/exceptions-handling-service";
import { enterV13TestIfNeeded } from "services/ab-tests/monetization-ab-tests-service";
import { inputTypes } from "client/services/form-service/form-inputs";
import { getInputDataByName } from "client/services/form-service/form-service";
import { HUBSPOT_API_COMPANY_SIZE, HUBSPOT_ELIGIBLE_FOR_BAM, PII_PARAMS } from "client/services/hubspot-service/hubspot-constants";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import omit from "lodash/omit";
import sortBy from "lodash/sortBy";
import * as Sentry from "@sentry/nextjs";
import { isBC } from "services/contact-sales";
import { extractPathFromUrl } from "utils/url";
import DefaultProps from "./default-props";
import { HUBSPOT_TO_LEAD_DATA_MAP } from "./consts";
import { SMALLEST_COMPANY_SIZE } from "client/services/form-service/form-constants";
import { setAdaOnPage, setBookAMeetingInfoOnPage } from "client/services/contact-sales-service/contact-sales-service";
import { withLoadingContext } from "contexts/loading-screen-context";
import { LOADER_TYPES } from "contexts/types/loader-types";
import { withSystemConfig } from "contexts/system-config-context";
const HUBSPOT_INVALID_EMAIL_ERROR_TYPE = "INVALID_EMAIL";
const GARTNER_REPORT_URL = "https://www.gartner.com/doc/reprints?id=1-2AKZAKIR&ct=220714&st=sb";
class HubspotContactForm extends PureComponent {
    componentDidMount() {
        const { formId } = this.props;
        trackEvent(HUBSPOT_FORM_READY, {
            kind: formId
        });
    }
    render() {
        const { withPrivacyNotice, formId, overrideCampaignId, backgroundLayers, isMobileOrTabletBrowser, formTitle, lastNameFirst, formSubTitle, isV2, dontRenderPostFormSubmit, restProps, privacyNoticeText, ctaProps } = this.props;
        const { firstFormSubmitted } = this.state;
        const formConfig = getContactFormConfigById({
            formId,
            overrideCampaignId,
            withPrivacyNotice,
            formTitle,
            lastNameFirst,
            isV2,
            firstFormSubmitted,
            privacyNoticeText,
            ctaProps
        });
        const submitScreenData = this.getSubmitScreenData();
        return /*#__PURE__*/ _jsx("div", {
            className: "hubspot-contact-form-wrapper",
            children: /*#__PURE__*/ _jsx(BaseForm, {
                backgroundLayers: isMobileOrTabletBrowser ? 0 : backgroundLayers,
                formConfig: formConfig,
                submitFormAsyncCallback: this.sendFormToHubspot,
                submitScreenData: submitScreenData,
                onInputBlur: this.onInputBlur,
                renderPrivacyNotice: withPrivacyNotice,
                dontRenderPostFormSubmit: dontRenderPostFormSubmit,
                isV2: isV2,
                handleFirstFormSubmit: this.handleFirstFormSubmit,
                handleBackButtonClicked: this.handleBackButtonClicked,
                firstFormSubmitted: firstFormSubmitted,
                restProps: restProps,
                formSubTitle: formSubTitle,
                onEmailChange: this.onEmailChange
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getFirstErrorMessageFromResponse", (response)=>{
            var _response_errors_, _response_errors, _response_errors_1, _response_errors1;
            if ((response === null || response === void 0 ? void 0 : (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType) === HUBSPOT_INVALID_EMAIL_ERROR_TYPE) {
                // Formatting Hubspot message into more user friendly one for known message types
                return "form.errors.invalidEmailError";
            }
            return response === null || response === void 0 ? void 0 : (_response_errors1 = response.errors) === null || _response_errors1 === void 0 ? void 0 : (_response_errors_1 = _response_errors1[0]) === null || _response_errors_1 === void 0 ? void 0 : _response_errors_1.message;
        });
        _define_property(this, "convertValuesToHubspotFormat", (formData)=>{
            const { withPrivacyNotice, formId, overrideCampaignId, formTitle, lastNameFirst } = this.props;
            const formConfig = getContactFormConfigById({
                formId,
                overrideCampaignId,
                withPrivacyNotice,
                formTitle,
                lastNameFirst
            });
            const convertedData = [];
            formData.forEach((inputField)=>{
                const inputConfig = getInputDataByName(formConfig, inputField.name);
                if (inputConfig.type === inputTypes.MULTI_SELECT) {
                    if (Array.isArray(inputField.value)) {
                        const order = inputConfig.options.map((item)=>item.value);
                        const sortedInputField = {
                            name: inputField.name,
                            // sort by the order of the options in the config
                            value: sortBy(inputField.value, function(item) {
                                return order.indexOf(item.value);
                            })
                        };
                        convertedData.push({
                            name: sortedInputField.name,
                            value: sortedInputField.value.map((option)=>option.value).join(";")
                        });
                    } else {
                        convertedData.push({
                            name: inputField.name,
                            value: inputField.value.value
                        });
                    }
                } else {
                    convertedData.push(inputField);
                }
            });
            return convertedData;
        });
        _define_property(this, "convertToLeadData", (convertedFormData)=>{
            const leadData = {};
            Object.keys(HUBSPOT_TO_LEAD_DATA_MAP).forEach((key)=>{
                const hubspotKey = HUBSPOT_TO_LEAD_DATA_MAP[key];
                const field = convertedFormData.find((item)=>item.name === hubspotKey);
                if (field) {
                    leadData[key] = field.value;
                }
            });
            return leadData;
        });
        _define_property(this, "sendHubspotStagingFormIfNeeded", function() {
            var _ref = _async_to_generator(function*(portalId, formId, fields) {
                if (portalId != TEST_PORTAL_ID || formId != TEST_CONTACT_SALES_HUBSPOT_FORM_ID) {
                    let testResponse = null;
                    try {
                        testResponse = yield sendHubspotForm(TEST_PORTAL_ID, TEST_CONTACT_SALES_HUBSPOT_FORM_ID, fields, false);
                    } catch (error) {
                        console.error("Error sending Hubspot test form:", error);
                    }
                    const testSuccess = testResponse && !testResponse.status;
                    if (!testSuccess) {
                        trackEvent(HUBSPOT_FORM_TEST_SUBMIT_FAILED);
                    }
                }
            });
            return function(portalId, formId, fields) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "getCSData", function() {
            var _ref = _async_to_generator(function*(email, timeout) {
                try {
                    const startTime = performance.now();
                    const apiResponse = yield isBC(email, timeout);
                    const timeToResponse = performance.now() - startTime;
                    trackEvent(CONTACT_SALES_ENRICHEMNT_CALL_SUCCESS, {
                        kind: timeToResponse
                    });
                    return apiResponse;
                } catch (error) {
                    Sentry.captureMessage(`cs enrichment failed with error: ${error.message || error}`);
                    trackEvent(CONTACT_SALES_ENRICHEMNT_CALL_FAILED, {
                        kind: error.message || error
                    });
                }
            });
            return function(email, timeout) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "isSB", (companySizeValue, enrichment)=>{
            const isSMBByForm = companySizeValue === SMALLEST_COMPANY_SIZE;
            return isSMBByForm && !(enrichment === null || enrichment === void 0 ? void 0 : enrichment.isBC);
        });
        _define_property(this, "toggleLoader", ()=>{
            const { enableLoader, setLoadingScreen, setLoadingScreenType, loadingScreenType } = this.props;
            if (!enableLoader) return;
            loadingScreenType !== LOADER_TYPES.BOOK_A_MEETING && setLoadingScreenType(LOADER_TYPES.BOOK_A_MEETING);
            setLoadingScreen((isLoading)=>!isLoading);
        });
        var _this = this;
        _define_property(this, "handlePostSubmission", function() {
            var _ref = _async_to_generator(function*(formData, companySizeValue) {
                const { bookAMeetingFlowUrl, urlToRedirectAfterSubmission, urlToRedirectAfterSubmissionForSmallBusinesses, isBAMDisabled, bamTimeout } = _this.props;
                const extraFields = [];
                const enrichment = _this.enrichmentPromiseRef ? yield _this.enrichmentPromiseRef : null;
                let redirectUrl = urlToRedirectAfterSubmission;
                if (_this.isSB(companySizeValue, enrichment)) {
                    setAdaOnPage(formData);
                    redirectUrl = urlToRedirectAfterSubmissionForSmallBusinesses;
                } else if (!isBAMDisabled && bookAMeetingFlowUrl) {
                    const bamRedirectionUrl = yield setBookAMeetingInfoOnPage(formData, enrichment, bookAMeetingFlowUrl, bamTimeout);
                    extraFields.push({
                        name: HUBSPOT_ELIGIBLE_FOR_BAM,
                        value: !!bamRedirectionUrl
                    });
                    redirectUrl = bamRedirectionUrl || urlToRedirectAfterSubmission;
                }
                return {
                    extraFields,
                    redirectUrl
                };
            });
            return function(formData, companySizeValue) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this1 = this;
        _define_property(this, "sendFormToHubspot", function() {
            var _ref = _async_to_generator(function*(formData) {
                var _getValueFromHSFields;
                var _getValueFromHSFields_value;
                const companySizeValue = (_getValueFromHSFields_value = (_getValueFromHSFields = getValueFromHSFields(formData, HUBSPOT_API_COMPANY_SIZE)) === null || _getValueFromHSFields === void 0 ? void 0 : _getValueFromHSFields.value) !== null && _getValueFromHSFields_value !== void 0 ? _getValueFromHSFields_value : null;
                try {
                    var _document, _document1;
                    const { formId, portalId, abTests, cookies, isV13PricingVersion, withPrivacyNotice, source, overrideCampaignId, cloudfrontViewerCountry, externalEventsForSubmit, hubspotFromHiddenField } = _this1.props;
                    const referrePage = ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) ? extractPathFromUrl((_document1 = document) === null || _document1 === void 0 ? void 0 : _document1.referrer) : null;
                    const hiddenDataParams = generateHiddenData({
                        withPrivacyNotice,
                        source,
                        overrideCampaignId,
                        cookies,
                        cloudfrontViewerCountry,
                        referrePage,
                        hubspotFromHiddenField
                    });
                    const startTime = performance.now();
                    _this1.toggleLoader();
                    const convertedData = _this1.convertValuesToHubspotFormat(formData);
                    const fields = [
                        ...convertedData,
                        ...hiddenDataParams
                    ];
                    const { redirectUrl, extraFields } = yield _this1.handlePostSubmission(convertedData, companySizeValue);
                    fields.push(...extraFields);
                    const response = yield sendHubspotForm(portalId, formId, fields);
                    _this1.sendHubspotStagingFormIfNeeded(portalId, formId, fields);
                    const success = response && !response.status; // Success request has no status entry
                    let errorMessage = null;
                    if (!success) {
                        var _response_errors_;
                        const firstErrorType = (response === null || response === void 0 ? void 0 : response.errors) && (response === null || response === void 0 ? void 0 : (_response_errors_ = response.errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType);
                        errorMessage = _this1.getFirstErrorMessageFromResponse(response);
                        trackEvent(HUBSPOT_FORM_SUBMIT_FAILED, {
                            kind: formId,
                            info1: firstErrorType,
                            info2: errorMessage
                        });
                    } else {
                        let data;
                        try {
                            data = omit(_object_spread_props(_object_spread({}, mapValues(keyBy(fields, "name"), "value")), {
                                leadsource: source,
                                duration: Math.round(performance.now() - startTime)
                            }), PII_PARAMS);
                        } catch (e) {
                            Sentry.captureException(e);
                        }
                        trackEvent(HUBSPOT_FORM_SUBMIT_CLICKED, {
                            kind: formId,
                            info1: companySizeValue,
                            data
                        });
                        fireGtmEvent(DataLayerEventTypes.HUBSPOT_FORM_SUBMITTED, {
                            formId,
                            lead_data: _this1.convertToLeadData(convertedData)
                        });
                        if (externalEventsForSubmit) {
                            trackEvent(externalEventsForSubmit.eventType, externalEventsForSubmit.data);
                        }
                    }
                    enterV13TestIfNeeded(abTests, cookies, undefined, isV13PricingVersion);
                    !redirectUrl && _this1.toggleLoader();
                    return {
                        success,
                        errorMessage,
                        redirectUrl
                    };
                } catch (e) {
                    _this1.toggleLoader();
                    yield handleClientException({
                        e,
                        bbEventParams: {
                            name: CONTACT_SALES_FORM_SUBMISSION_FAILED
                        }
                    });
                }
            });
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "getSubmitScreenData", ()=>{
            const { overrideCampaignId } = this.props;
            switch(overrideCampaignId){
                case IPO_CAMPAIGN_ID:
                    return {
                        titleKey: "forms.thanksPage.ipoCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.ipoCampaign.subTitleHtml"
                    };
                case GARTNER_CAMPAIGN_ID:
                    return {
                        titleKey: "forms.thanksPage.gartnerCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.gartnerCampaign.subTitleHtml2023",
                        footerHtml: "forms.thanksPage.gartnerCampaign.footerHtml",
                        downloadButtonLink: GARTNER_REPORT_URL
                    };
                default:
                    return null;
            }
        });
        _define_property(this, "onInputBlur", (name, value)=>{
            const { formId } = this.props;
            if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                trackEvent(HUBSPOT_FORM_INPUT_TYPED, {
                    kind: formId,
                    info1: name,
                    info2: value === null || value === void 0 ? void 0 : value.length
                });
            }
            trackEvent(HUBSPOT_FORM_INPUT_BLUR, {
                kind: formId,
                info1: name,
                info2: value === null || value === void 0 ? void 0 : value.length
            });
        });
        _define_property(this, "handleFirstFormSubmit", ()=>{
            this.setState({
                firstFormSubmitted: true
            });
        });
        _define_property(this, "handleBackButtonClicked", ()=>{
            trackEvent(CONTACT_SALES_BACK_BUTTON_CLICKED);
            this.setState({
                firstFormSubmitted: false
            });
        });
        var _this2 = this;
        _define_property(this, "onEmailChange", function() {
            var _ref = _async_to_generator(function*(email) {
                const { sendEmailToEnrichment } = _this2.props;
                _this2.enrichmentPromiseRef = sendEmailToEnrichment && _this2.getCSData(email);
            });
            return function(email) {
                return _ref.apply(this, arguments);
            };
        }());
        this.enrichmentPromiseRef = null;
        this.state = {
            firstFormSubmitted: false
        };
    }
}
HubspotContactForm.defaultProps = DefaultProps;
export default withSystemConfig(withAbTests(withGenericConfig(withLoadingContext(HubspotContactForm))));
